import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Box, Button, CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { makeGetRequest } from 'utils/api'
import { useParams } from 'react-router-dom'
import { convertToUserDateFormate, formatTextWithLineBreaks } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// import { useLocation } from 'react-router-dom'

export default function OperationFiTable({ url }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [more, setMore] = useState(true)
  const params = useParams()
  const { slug } = params
  useEffect(() => {
    if (url) {
      setMore(true)
      getOperationFi()
    }
  }, [url])
  const getOperationFi = async (pagination = false) => {
    let getUrl = `/api/Finance/dashboard-report/${slug}/` + url + '&table=true'
    if (pagination) getUrl = getUrl + pagination
    const response = await makeGetRequest(getUrl, {}, true)
    if (response.status === 200) {
      if (response.data.length === 0) {
        setMore(false)
      }
      if (pagination) {
        setData([...data, ...response.data])
      } else {
        setData(response.data)
      }
    }
  }
  const handleChangeRowsPerPage = (event) => {
    let pagination = `&offset=${data.length}`
    getOperationFi(pagination)
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{t('dashboardDetail.colDate')}</TableCell>
            <TableCell>{t('dashboardDetail.colAccount')}</TableCell>
            <TableCell>{t('dashboardDetail.colLabel')}</TableCell>

            <TableCell>{t('dashboardDetail.colCategory')}</TableCell>
            <TableCell>{t('dashboardDetail.colSubcategory')}</TableCell>

            <TableCell>{t('dashboardDetail.colAmount')}</TableCell>
            <TableCell>{t('dashboardDetail.colCurrency')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={5}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : (
            data &&
            data.map((row) => (
              <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {convertToUserDateFormate(siteUser.user, row.Date)}
                </TableCell>
                <TableCell>{row?.NCompte?.ncNom}</TableCell>
                <TableCell style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                  {formatTextWithLineBreaks(row.Libelle)}
                </TableCell>
                {/* <TableCell>{row.compte}</TableCell> */}
                <TableCell>
                  {row.SousCategorie.length > 0 && row.SousCategorie[0].Categorie}
                </TableCell>
                <TableCell>
                  {row.SousCategorie.length > 0 && row.SousCategorie[0].SousCategorie}
                </TableCell>
                <TableCell>{row.Montant}</TableCell>
                <TableCell>{row?.NCompte?.Devise}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {data.length > 19 && more && (
        <Box display={'flex'} justifyContent={'center'}>
          <Button onClick={handleChangeRowsPerPage}>{t('dashboardDetail.loadMore')}</Button>
        </Box>
      )}
      {data.length === 0 && (
        <Box className="text-center" style={{ color: 'black !important' }} py={5}>
          {t('dashboardDetail.noData')}
        </Box>
      )}
    </TableContainer>
  )
}
